import { useState } from "react"
import { mutate } from "swr"
import * as DeliveryRouteApi from "../../../apis/delivery-route"
import type { ICreateRouteInput, IDeliveryRoute } from "../../../apis/delivery-route"

const invalidate = () =>
  mutate((key) => Array.isArray(key) && (key[0] === "delivery-routes" || key[0] === "delivery-route"), undefined, { revalidate: true })

export function useRouteMutations() {
  const [submitting, setSubmitting] = useState(false)
  const [error, setError] = useState<Error | null>(null)

  async function wrap<T>(fn: () => Promise<T>): Promise<T> {
    setSubmitting(true)
    setError(null)
    try {
      const r = await fn()
      await invalidate()
      return r
    } catch (e) {
      const err = e instanceof Error ? e : new Error(String(e))
      setError(err)
      throw err
    } finally {
      setSubmitting(false)
    }
  }

  return {
    submitting,
    error,
    create:       (data: ICreateRouteInput): Promise<IDeliveryRoute> => wrap(() => DeliveryRouteApi.create(data)),
    start:        (id: string) => wrap(() => DeliveryRouteApi.start(id)),
    loadingComplete: (id: string) => wrap(() => DeliveryRouteApi.loadingComplete(id)),
    complete:     (id: string) => wrap(() => DeliveryRouteApi.complete(id)),
    reorderStops: (id: string, ids: string[]) => wrap(() => DeliveryRouteApi.reorderStops(id, { orderedStopIds: ids })),
    optimize:     (id: string, body: Parameters<typeof DeliveryRouteApi.optimize>[1]) =>
                    wrap(() => DeliveryRouteApi.optimize(id, body)),
  }
}
